import Box from '@mui/material/Box';
import {
  OrganisationSwitcher,
  SideNav,
  TBasicSideNavProps,
} from '@verifime/components';
import tokens from '@verifime/design-tokens';
import helpResources from './help-resources.json';
import { useOrganisations } from './useOrganisations';

type TClientPortalSideNavProps = Omit<
  TBasicSideNavProps,
  'toggleColorMode' | 'navItemHrefProcessor' | 'resources' | 'helpCentreUrl'
> & {
  homePath: string;
};

export default function ClientPortalSideNav({ homePath, ...props }: TClientPortalSideNavProps) {
  const { organisations, defaultOrgId, handleChangeOrgId, navItemHrefProcessor } =
    useOrganisations(homePath);

  const additionalNavHeaderComponents = () => (
    <>
      {organisations?.length > 0 && (
        <Box paddingX={tokens.spacingXs} paddingY={tokens.spacingBase} maxWidth={tokens.size2xs}>
          <OrganisationSwitcher
            defaultOrgId={defaultOrgId}
            potentialOrgs={organisations}
            onChangeCurrentOrgId={handleChangeOrgId}
          />
        </Box>
      )}
    </>
  );

  return (
    <SideNav
      additionalNavHeaderComponents={additionalNavHeaderComponents}
      navItemHrefProcessor={navItemHrefProcessor}
      resources={helpResources.resources}
      helpCentreUrl={helpResources.helpCentreUrl}
      {...props}
    />
  );
}
